import { Clickable, Col, H2, P, Row, TypeWrapper, Wrapper } from '@ahmdigital/ui';

import { URLS } from '../../../../../models/url/constants';
import CHEAPEST_PRODUCT from '../../../../../models/product/cheapest-product';
import UrlService from '../../../../../models/url';

const cheapestProductUrl = UrlService.getProductUrl(CHEAPEST_PRODUCT.HOSPITAL);

const MlsSection = () => (
  <Wrapper>
    <Row>
      <Col df={8} dfOffset={2} sm={12} smOffset={0} variant="marginBottomSpacer1">
        <TypeWrapper variant="center">
          <H2 variant="marginBottomSpacer4">What is the Medicare Levy Surcharge (MLS)?</H2>
          <P>
            The Medicare Levy Surcharge (MLS) is an extra tax for higher‑income earners who don’t hold an appropriate
            level of private <Clickable to={URLS.SALES.HEALTH_INSURANCE_HOSPITAL_COVER}>hospital cover</Clickable> for
            themselves and any for the full year. It’s set by the Government, and it’s calculated based on your{' '}
            <Clickable to={URLS.THIRD_PARTY.ATO_MEDICARE_LEVY_SURCHARGE_INCOME_THRESHOLDS}>
              income for Medicare Levy Surcharge purposes
            </Clickable>{' '}
            — which includes taxable income plus things like reportable fringe benefits and investment losses.
          </P>
          <P>
            The good news though — holding any eligible ahm hospital cover means you could be exempt from paying the
            MLS. Even taking out our <Clickable to={cheapestProductUrl}>cheapest basic hospital cover</Clickable> can
            help you avoid the surcharge, while offering a little peace of mind in case of emergencies too.
          </P>
          <P>
            Just remember: to avoid the MLS, you need{' '}
            <Clickable to={URLS.SALES.HEALTH_INSURANCE}>private health insurance</Clickable> that includes{' '}
            <Clickable to={URLS.SALES.HEALTH_INSURANCE_HOSPITAL_COVER}>hospital cover</Clickable> — extras‑only policies
            won’t count.
          </P>
          <P>
            Learn more about the MLS at <Clickable to={URLS.THIRD_PARTY.PRIVATE_HEALTH}>privatehealth.gov.au</Clickable>
            .
          </P>
        </TypeWrapper>
      </Col>
    </Row>
  </Wrapper>
);

export default MlsSection;
